import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DatePipe, NgClass, NgFor, NgIf } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { finalize } from 'rxjs/operators';
import { Area } from 'src/app/shared/model/tickets/area.model';
import { TicketsService } from '../tickets.service';
import { UrlConstantes } from 'src/app/utilerias/constantes/urlconstantes';
import { UtileriasService } from 'src/app/utilerias/service/utilerias.service';
import { FiltroTicketEnum, FiltroTicketDTO } from 'src/app/shared/enum/filtro-ticket.num';
import { Tickets } from 'src/app/shared/model/tickets/tickets.model';
import { ConsultaList } from 'src/app/shared/model/core/ConsultaList.model';
import { TicketsEstatus } from 'src/app/utilerias/enums/tickets-estatus.enum';
import { Formulario } from 'src/app/shared/model/tickets/formulario';
import { Msg } from 'src/app/utilerias/mensajes/Msg';

@Component({
  selector: 'app-gestion-tickets-depurados',
  standalone: true,
  templateUrl: './gestion-tickets-depurados.component.html',
  imports: [
    NgIf,
    NgFor,
    NgClass,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOption,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    DatePipe,
  ],
})
export class GestionTicketsDepuradosComponent implements OnInit {
  @Output() mostrarDetalle = new EventEmitter<Formulario>();

  readonly pageSizeOptions = [5, 10, 20];
  itemsPerPage = 5;
  currentPage = 1;
  totalItems = 0;
  loading = false;
  consultaRealizada = false;

  areas: Area[] = [];
  options!: FormGroup;
  areaSeleccionada: Area | null = null;
  filtros: string[] = [];
  filtroDto: FiltroTicketDTO = new FiltroTicketDTO();
  ticketsParmas = new ConsultaList<Tickets>();
  ticketsDepurados: Tickets[] = [];
  formulario = new Formulario();
  ticketSeleccionado!: Tickets;
  mostrarTabla = false;

  constructor(
    private ticketService: TicketsService,
    private fb: FormBuilder,
    private utils: UtileriasService,
    private msg: Msg,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.mostrarTabla = false;
    this.invertirVistas(true);
    this.options = this.fb.group({
      asuntoCtrl: [''],
      dateCtrl: [''],
      areaCtrl: [''],
      filtrosCtrl: new FormControl<string[]>([]),
    });
    this.filtros = Object.keys(FiltroTicketEnum);
    this.consultaAreas();
  }

  consultaAreas(): void {
    this.ticketService.consultarArea(UrlConstantes.consultarArea).subscribe((res) => {
      if (res != null) {
        this.areas = res.list ?? [];
        this.areaSeleccionada = this.areas[0] ?? null;
        this.options.patchValue({ areaCtrl: this.areaSeleccionada }, { emitEvent: false });
        this.cdr.detectChanges();
      }
    });
  }

  mostrarOcultarFitros(): void {
    this.mostrarTabla = false;
    this.consultaRealizada = false;
    this.ticketsDepurados = [];
    this.totalItems = 0;

    const nuevos = (this.options.get('filtrosCtrl')?.value as string[] | null) ?? [];
    this.filtroDto.nombre = nuevos.includes(FiltroTicketEnum.NOMBRE);
    this.filtroDto.fecha = nuevos.includes(FiltroTicketEnum.FECHA);

    if (!this.filtroDto.nombre) {
      this.options.patchValue({ asuntoCtrl: '' }, { emitEvent: false });
      this.ticketsParmas.param2 = '';
    }

    if (!this.filtroDto.fecha) {
      this.options.patchValue({ dateCtrl: '' }, { emitEvent: false });
      this.ticketsParmas.param3 = '';
    }

    this.cdr.detectChanges();
  }

  clear(): void {
    this.options.patchValue(
      {
        asuntoCtrl: '',
        dateCtrl: '',
        filtrosCtrl: [],
      },
      { emitEvent: false }
    );
    this.filtroDto = new FiltroTicketDTO();
    this.ticketsParmas.param2 = '';
    this.ticketsParmas.param3 = '';
    this.ticketsDepurados = [];
    this.totalItems = 0;
    this.currentPage = 1;
    this.mostrarTabla = false;
    this.consultaRealizada = false;
    this.cdr.detectChanges();
  }

  consultaTicketsDepurados(): void {
    if (this.validaDatosRuqeridos()) {
      this.currentPage = 1;
      this.cargarTicketsDepurados(this.currentPage);
    }
  }

  verDetalleTicket(ticket: Tickets): void {
    this.invertirVistas(false);
    this.ticketSeleccionado = ticket;
    this.mostrarDetalle.emit(this.formulario);
  }

  invertirVistas(invertir: boolean): void {
    this.formulario.mostrarFrmControl = invertir;
    this.formulario.mostrarFrmDetalle = !invertir;
    this.cdr.detectChanges();
  }

  regresarAPrincipal(): void {
    this.formulario.mostrarFrmControl = true;
    this.formulario.mostrarFrmDetalle = false;
    this.cdr.detectChanges();
  }

  mostrarMascara(mostrar: boolean): void {
    if (!mostrar) {
      this.cdr.detectChanges();
    }
  }

  onAreaChange(area: Area): void {
    this.areaSeleccionada = area;
    this.mostrarTabla = false;
    this.consultaRealizada = false;
    this.ticketsDepurados = [];
    this.totalItems = 0;
    this.cdr.detectChanges();
  }

  onDateChange(): void {
    this.mostrarTabla = false;
    this.consultaRealizada = false;
    this.ticketsParmas.param3 = this.options.get('dateCtrl')?.value ?? '';
    this.cdr.detectChanges();
  }

  onAsuntoChange(value: string): void {
    this.mostrarTabla = false;
    this.consultaRealizada = false;
    this.ticketsParmas.param2 = value;
    this.cdr.detectChanges();
  }

  validaDatosRuqeridos(): boolean {
    if (this.areaSeleccionada == null) {
      this.msg.warningCall('Debe seleccionar un área para realizar la búsqueda', null, null);
      return false;
    }
    return true;
  }

  cargarTicketsDepurados(page: number): void {
    this.consultaRealizada = true;
    this.loading = this.ticketsDepurados.length === 0;
    this.cdr.detectChanges();
    this.syncFiltersToQuery();
    this.ticketsParmas.regInicial = (page - 1) * this.itemsPerPage;
    this.ticketsParmas.regFinal = this.itemsPerPage;
    this.ticketsParmas.param4 = this.areaSeleccionada?.id;

    this.ticketService
      .consultaticketsDecuparodos(this.ticketsParmas)
      .pipe(
        finalize(() => {
          this.loading = false;
          this.cdr.detectChanges();
        })
      )
      .subscribe({
        next: (res) => {
          const tickets = Array.isArray(res?.list) ? res.list : [];
          this.currentPage = page;
          this.totalItems = this.resolveTotalItems(res, tickets);
          this.ticketsDepurados = tickets.map((ticket) => ({
            ...ticket,
            nombreEstaus: TicketsEstatus[ticket.id_estatus] ?? ticket.nombreEstaus,
          }));
          this.mostrarTabla = this.ticketsDepurados.length > 0;

          const totalPages = this.totalPages;
          if (totalPages > 0 && this.currentPage > totalPages) {
            this.cargarTicketsDepurados(totalPages);
            return;
          }

          this.cdr.detectChanges();
        },
        error: () => {
          this.ticketsDepurados = [];
          this.mostrarTabla = false;
          this.totalItems = 0;
          this.cdr.detectChanges();
        },
      });
  }

  onPageSizeChange(value: number): void {
    this.itemsPerPage = Number(value);
    if (this.consultaRealizada) {
      this.cargarTicketsDepurados(1);
      return;
    }
    this.cdr.detectChanges();
  }

  onPageChange(page: number): void {
    if (page === this.currentPage || page < 1 || page > this.totalPages) {
      return;
    }
    this.cargarTicketsDepurados(page);
  }

  firstPage(): void {
    this.onPageChange(1);
  }

  previousPage(): void {
    this.onPageChange(this.currentPage - 1);
  }

  nextPage(): void {
    this.onPageChange(this.currentPage + 1);
  }

  lastPage(): void {
    this.onPageChange(this.totalPages);
  }

  get totalPages(): number {
    return this.totalItems > 0 ? Math.ceil(this.totalItems / this.itemsPerPage) : 0;
  }

  get showPagination(): boolean {
    return this.consultaRealizada && this.totalItems > 0;
  }

  get rangeEnd(): number {
    return Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
  }

  getStatusLabel(ticket: Tickets): string {
    return ticket?.nombreEstaus ? String(ticket.nombreEstaus) : 'Sin estatus';
  }

  getStatusClass(ticket: Tickets): string {
    switch (ticket?.id_estatus) {
      case TicketsEstatus.CANCELADA:
        return 'is-inactive';
      case TicketsEstatus.ATENDIDA:
      case TicketsEstatus.VOBO:
        return 'is-active';
      default:
        return 'is-pending';
    }
  }

  getPaginationItems(): Array<number | string> {
    if (this.totalPages <= 1) {
      return [1];
    }

    const pages = new Set<number>([
      1,
      this.totalPages,
      this.currentPage - 1,
      this.currentPage,
      this.currentPage + 1,
    ]);
    const sortedPages = Array.from(pages)
      .filter((page) => page >= 1 && page <= this.totalPages)
      .sort((a, b) => a - b);

    const items: Array<number | string> = [];
    for (let index = 0; index < sortedPages.length; index++) {
      const page = sortedPages[index];
      const previous = sortedPages[index - 1];
      if (previous && page - previous > 1) {
        items.push(`ellipsis-${previous}-${page}`);
      }
      items.push(page);
    }

    return items;
  }

  isPageNumber(item: number | string): item is number {
    return typeof item === 'number';
  }

  private syncFiltersToQuery(): void {
    this.ticketsParmas.param2 = this.filtroDto.nombre
      ? (this.options.get('asuntoCtrl')?.value ?? '')
      : '';
    this.ticketsParmas.param3 = this.filtroDto.fecha
      ? (this.options.get('dateCtrl')?.value ?? '')
      : '';
  }

  private resolveTotalItems(response: ConsultaList<Tickets>, tickets: Tickets[]): number {
    const payload = response as ConsultaList<Tickets> & Record<string, unknown>;
    const candidates = [
      payload?.param4,
      payload?.pTotalItems,
      payload?.totalItems,
      payload?.totalRegistros,
      payload?.totalElements,
    ];

    for (const candidate of candidates) {
      const parsed = Number(candidate);
      if (Number.isFinite(parsed) && parsed > 0) {
        return parsed;
      }
    }

    const currentItems = Array.isArray(tickets) ? tickets.length : 0;
    if (currentItems === 0) {
      return 0;
    }

    return (this.currentPage - 1) * this.itemsPerPage + currentItems;
  }
}
